import { render, staticRenderFns } from "./BaseAuthView.vue?vue&type=template&id=60354be0&"
import script from "./BaseAuthView.vue?vue&type=script&lang=js&"
export * from "./BaseAuthView.vue?vue&type=script&lang=js&"
import style0 from "./BaseAuthView.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports